import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import {
  requestActiveMiners,
  requestActiveTrialMiners,
  requestIsFirstPurchase,
} from 'store/api/cuverse-api/purchase/purchase.service';
import {
  MinerDataResponseSchema,
  TMinersData,
} from 'store/api/cuverse-api/purchase/types/purchase-active-miners.interface';
import {
  IsFirstPurchaseSchema,
  TFirstPurchaseData,
} from 'store/api/cuverse-api/purchase/types/purchase-first-purchase.interface';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';
import { notifyError } from 'utils/notify/notify.utils';

export const fetchActiveMinersThunkAction = createAsyncThunk(
  'miners/fetchActiveMiners',
  async (): Promise<TMinersData> => {
    return await requestWithZodSchema(requestActiveMiners, MinerDataResponseSchema).catch(
      (error) => {
        notifyError(i18n.t('notifyMessages.purchase.minersRequestError'));
        throw error;
      },
    );
  },
);

export const fetchActiveTrialMinersAction = createAsyncThunk(
  'miners/fetchActiveTrialMiners',
  async (): Promise<TMinersData> => {
    return await requestWithZodSchema(requestActiveTrialMiners, MinerDataResponseSchema);
  },
);

export const fetchIsFirstPurchaseAction = createAsyncThunk(
  'miners/fetchIsFirstPurchase',
  async (): Promise<TFirstPurchaseData> => {
    return await requestWithZodSchema(requestIsFirstPurchase, IsFirstPurchaseSchema);
  },
);
